export default __webpack_public_path__ + "static/media/distancia.c9fe7eb1.svg";